import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { NewsPageContext } from "@insite/content-library/Pages/NewsPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    page: getCurrentPage(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface NewsPageViewStyles {
    authorText?: TypographyProps;
    publishDateText?: TypographyProps;
    newsWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    dateAndAuthorWrapper?: InjectableCss;
}

export const newsPageViewStyles: NewsPageViewStyles = {
    newsWrapper: {
        css: css``,
    },
    contentWrapper: {
        css: css`
            margin-top: 8px;
            .data_wrapper {
                > h3,
                > h5,
                > div {
                    margin-bottom: 25px;
                }
                > h2 {
                    font-size: 28px;
                    margin-bottom: 0;
                }
                > h3 {
                    font-size: 22px;
                    font-weight: ${TYPOGRAPHY.weight.base};
                }
                p {
                    font-size: ${TYPOGRAPHY.size.small};
                    margin-bottom: 15px;
                }
                > h5 {
                    margin-top: 5px;
                    color: #0b70b7;
                    font-size: ${TYPOGRAPHY.size.small};
                }
            }
            .contact-wrapper {
                margin-top: 25px;
                background: #f1f6fb;
                padding: 19px 24px;
                h5 {
                    font-size: 16px;
                    color: #0b70b7;
                    border-bottom: 1px solid #3c8dc6;
                    padding-bottom: 10px;
                    font-weight: ${TYPOGRAPHY.weight.base};
                }
                .contact-info {
                    display: flex;
                    justify-content: space-between;
                    .name {
                        display: flex;
                        flex-direction: column;
                        h2 {
                            margin-bottom: 0;
                            font-size: 23px;
                        }
                        span {
                            font-size: ${TYPOGRAPHY.size.smaller};
                        }
                    }
                    .contact-list {
                        ul {
                            display: flex;
                            list-style: none;
                            padding: 0;
                            font-size: ${TYPOGRAPHY.size.smaller};
                            li :not(:last-child) {
                                padding-right: 1.5rem;
                            }
                            li span {
                                padding-right: 10px;
                                vertical-align: bottom;
                                color: #000;
                            }
                        }
                    }
                }
            }
            .content {
                background: red;
                h3 {
                    font-size: 22px;
                    margin-bottom: 5px;
                }
            }
            @media (max-width: 1199px) and (min-width: 992px) {
                .contact-info {
                    flex-direction: Column;
                }
                .data_wrapper > h2 {
                    font-size: ${TYPOGRAPHY.size.largest};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            .contact-info {
                                flex-direction: column;
                                .contact-list {
                                    ul {
                                        flex-direction: column;
                                    }
                                    ul li :not(:last-child) {
                                        margin-bottom: 0.5rem;
                                    }
                                    li span {
                                        vertical-align: middle !important;
                                    }
                                }
                            }
                        `,
                        css`
                            .data_wrapper > h2 {
                                font-size: ${TYPOGRAPHY.size.largest};
                            }
                            .contact-info {
                                flex-direction: column;
                                .contact-list {
                                    ul li :not(:last-child) {
                                        padding-right: 3.5rem !important;
                                    }
                                }
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    authorText: {
        css: css`
            font-weight: bold;
            margin-right: 8px;
        `,
    },
    publishDateText: {
        css: css`
            font-style: italic;
        `,
    },
};

const styles = newsPageViewStyles;

const NewsPageView = ({ page }: Props) => {
    if (!page) {
        return null;
    }

    return (
        <StyledWrapper {...styles.newsWrapper} key={page.id}>
            {/* <StyledWrapper {...styles.dateAndAuthorWrapper}>
                {page.fields["author"] && <Typography {...styles.authorText}>{page.fields["author"]}</Typography>}
                {page.fields["publishDate"] && (
                    <Typography {...styles.publishDateText}>
                        <LocalizedDateTime
                            dateTime={new Date(page.fields["publishDate"])}
                            options={{ year: "numeric", month: "numeric", day: "numeric" }}
                        />
                    </Typography>
                )}
            </StyledWrapper> */}
            {(page.fields["newsSummary"] || page.fields["newsContent"]) && (
                <StyledWrapper {...styles.contentWrapper} data-test-selector="newslist_content">
                    {parse(page.fields["newsContent"], parserOptions)}
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(NewsPageView),
    definition: {
        group: "News Page",
        allowedContexts: ["NewsPage"],
    },
};

export default widgetModule;
